module.exports = __webpack_public_path__ + "static/media/ggt8.efdf5bad.jpg";